import { render, staticRenderFns } from "./BusinessConfigForm.vue?vue&type=template&id=2676a212&scoped=true&"
import script from "./BusinessConfigForm.vue?vue&type=script&lang=js&"
export * from "./BusinessConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2676a212",
  null
  
)

export default component.exports